import {useTranslation} from "react-i18next";
import {openRoomCloseModal, unSetRoomTabNotifier} from "../../../../../redux/actions/rooms/actions.js";
import {selectActiveRoomTab} from "../../../../../redux/actions/lobby/actions.js";
import {useDispatch} from "react-redux";

const GameRoomTab = function (props) {

    const {
        roomId,
        notifier,
        state,
        isActive,
        isTournamentRoom
    } = props;

    const {t} = useTranslation();
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(unSetRoomTabNotifier({roomId}));
        dispatch(selectActiveRoomTab({roomId}))
    }

    const onClose = (event) => {
        event.stopPropagation();

        if (state === 'FINISHED') return;

        if (state === 'PROGRESS') {
            dispatch(openRoomCloseModal({roomId}))
        }

        return dispatch(selectActiveRoomTab({roomId}))
    }

    return (
        <div className={`header-active-game-item-wrapper ${isActive ? "active" : ""}`} onClick={handleClick}>
            <div className={`header-active-game-item ${notifier ? 'blank-animation' : ''}`}>
                <i className={`${isTournamentRoom ? 'icon-cup' : 'icon-1'}`}/>
                <p>{t('tabs.game')} {roomId} </p>
                <i className="icon-close" onClick={(e) => onClose(e)}/>
            </div>
        </div>
    )
}

export default GameRoomTab